import { toast } from "react-toastify";
export default function showToast(message) {
  return toast.success(message,{duration:2000});
}
